import React, { useEffect, useState, useRef } from "react";
import { Grid, Button, Confirm, Form, Label, Icon } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import axios from "axios";
import { BaseUrlInvoice } from "../formcomponents/Constants";
import Swal from "sweetalert2";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { userData } from "../store/userData";
import { reduxForm, Field } from "redux-form";
import {
  NoteEditorField,
  renderTextField,
  renderOptionField,
} from "../formcomponents";

const ContactListWithCat = (props) => {
  const { handleSubmit, categoryId } = props;
  const navigate = useNavigate();
  const userDetail = userData();
  const isAdmin = userDetail?.userRole === 1;
  const [rowData, setRowData] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const gridApiRef = useRef(null);
  const [formValues, setFormValues] = useState({
    note: "",
    subject: "Rich Text Subject",
    bcc: "", // Initialize BCC as empty
    cc: "", // Initialize CC as empty
  });
  const [emailInput, setEmailInput] = useState(""); // Track input for new emails

  useEffect(() => {
    getContactList();
  }, []);

  const getContactList = () => {
    axios
      .post(BaseUrlInvoice + "accounts/listContact", {
        userId: userDetail.userId,
        categoryId: categoryId,
        getAll: categoryId === 0 ? true : false,
      })
      .then((res) => {
        setRowData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const defaultColDef = {
    sortable: true,
    editable: true,
    filter: true,
    floatingFilter: true,
  };

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 50,
    },
    { headerName: "Name", field: "companyName" },
    { headerName: "Contact Person", field: "contactPersonName" },
    { headerName: "Address", field: "address" },
    { headerName: "State", field: "state" },
    { headerName: "Country", field: "country" },
    { headerName: "Contact Number", field: "contactNumber" },
    { headerName: "Email", field: "contactEmail" },
    {
      headerName: "Edit/Delete",
      field: "ssContactId",
      filter: false,
      cellRendererFramework: (params) => (
        <div>
          <Button
            color="primary"
            disabled={!isAdmin}
            onClick={() => isAdmin && updateRecord(params)}
          >
            <AiFillEdit />
          </Button>
          <Button
            color="red"
            disabled={!isAdmin}
            onClick={() => isAdmin && deleteRecord(params)}
          >
            <AiFillDelete />
          </Button>
        </div>
      ),
    },
  ];

  const updateRecord = (params) => {
    navigate(`/create-contact-detail/${params.data.ssContactId}/${categoryId}`);
  };

  const deleteRecord = (params) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(BaseUrlInvoice + "accounts/deleteContact", {
            ssContactId: params.data.ssContactId,
          })
          .then(() => {
            Swal.fire("Deleted!", "Record has been deleted.", "success");
            getContactList();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  const exportToCSV = () => {
    const filteredRows = [];
    gridApiRef.current?.forEachNodeAfterFilterAndSort((rowNode) => {
      filteredRows.push(rowNode.data);
    });

    const ws = XLSX.utils.json_to_sheet(filteredRows);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(data, "Contact_List.xlsx");
  };

  const onGridReady = (params) => {
    gridApiRef.current = params.api;
  };

  const handleConfirm = () => {
    const selectedRows = gridApiRef.current?.getSelectedRows();
    const emails = selectedRows.map((row) => row.contactEmail);
    setSelectedEmails(emails);

    if (emails.length === 0) {
      Swal.fire(
        "No rows selected",
        "Please select at least one contact.",
        "info"
      );
    } else {
      setFormValues((prevValues) => ({
        ...prevValues,
        bcc: emails.join(", "), // Set BCC to selected emails
        cc: "", // Clear CC
      }));
      setShowConfirm(true); // Show confirmation modal
    }
  };

  const sendEmail = async () => {
    console.log("formValues", formValues);

    // Regular expression for validating email addresses
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Split and trim the emails, then filter out invalid ones
    const emailBccArray = formValues.bcc
      .split(",")
      .map((email) => email.trim())
      .filter((email) => emailRegex.test(email)); // Filter valid emails

    const postObject = {
      emailTo: [],
      emailFrom: formValues.emailFrom,
      emailCc: [],
      emailBcc: emailBccArray,
      subject: formValues.subject,
      body: formValues.note,
    };

    console.log(JSON.stringify(postObject, null, 2));

    // Show "Please wait..." message
    Swal.fire({
      title: "Please wait...",
      text: "Your email is being processed.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading(); // Show loading spinner
      },
    });

    await axios
      .post(BaseUrlInvoice + "accounts/sendBulkEmail", postObject)
      .then((res) => {
        setShowConfirm(false);

        console.log(res.data);

        if (res.data.errorCode === 200) {
          Swal.fire("Success", "Email has been sent", "success"); // Success message after the process
        } else {
          Swal.fire("Error", res.data.errorMessage, "error");
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire("Error", "Failed to send the email", "error"); // Error message if something goes wrong
      });
  };

  // Handle email input and add it to the list when pressing Enter or comma
  const handleKeyDown = (e) => {
    if ((e.key === "Enter" || e.key === ",") && emailInput.trim()) {
      e.preventDefault();
      const newEmail = emailInput.trim();
      if (validateEmail(newEmail)) {
        setSelectedEmails([...selectedEmails, newEmail]); // Add new email to list
        setEmailInput(""); // Clear input after adding
      } else {
        alert("Please enter a valid email address"); // Simple validation alert
      }
    }
  };

  const handleRemoveEmail = (emailToRemove) => {
    setSelectedEmails(
      selectedEmails.filter((email) => email !== emailToRemove)
    );
  };

  const handleInputChange = (e) => {
    setEmailInput(e.target.value);
  };

  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const emailOption = [
    { text: "Silver Star (office@ssbusinesssetup.com)", value: "STR" },
    { text: "Parmartours (reservations@travelpack365.com)", value: "PMR" },
    { text: "TravelPack365 (sales@travelpack365.com)", value: "TLP" },
    { text: "Tour Visionary (office@tourvisionary.com)", value: "TRV" },
  ];

  const sendOption = [
    { text: "BCC", value: "BCC" },
    { text: "TO", value: "TO" },
    { text: "CC", value: "CC" },
  ];
  return (
    <div>
      <Confirm
        header="Confirm Send Email"
        size="large"
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        confirmButton="Send Mail"
        onConfirm={() => {
          handleSubmit(sendEmail)();
        }}
        content={
          <div style={{ margin: "20px" }}>
            {/* <p>The following emails will receive the message via BCC:</p>
            <ul>
              {selectedEmails.map((email, idx) => (
                <li key={idx}>{email}</li>
              ))}
            </ul> */}

            {/* BCC Field with Email Tagging */}
            <Field
              name="emailFrom"
              label="From"
              options={emailOption}
              component={renderOptionField}
              onChange={(event) =>
                setFormValues({ ...formValues, emailFrom: event })
              }
            />

            <br />

            {/* <Field
              name="sendOption"
              label="From"
              options={sendOption}
              component={renderOptionField}
              onChange={(event) =>
                setFormValues({ ...formValues, sendOption: event })
              }
            /> */}

            {/* BCC Field with Email Tagging */}
            <Label>BCC</Label>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "6px",
                minHeight: "40px",
              }}
            >
              {selectedEmails.map((email, index) => {
                const isValid = validateEmail(email); // Validate the email
                return (
                  <Label
                    key={index}
                    color={isValid ? "teal" : "red"} // Conditionally set label color
                    basic
                    style={{ margin: "4px" }}
                  >
                    {email}
                    <Icon
                      name="delete"
                      onClick={() => handleRemoveEmail(email)}
                    />
                  </Label>
                );
              })}
              <input
                type="text"
                value={emailInput}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                placeholder="Add email..."
                style={{
                  border: "none",
                  outline: "none",
                  flex: 1,
                  minWidth: "120px",
                }}
              />
            </div>

            <br />

            {/* Subject Field */}
            <Field
              name="subject"
              component={renderTextField}
              label="Subject"
              // value={formValues.subject}
              onChange={(event) =>
                setFormValues({ ...formValues, subject: event.target.value })
              }
            />
            <br />
            {/* Note Field */}
            <Field
              name="note"
              component={NoteEditorField}
              label="Add a note to the email"
              onChange={(value) =>
                setFormValues({ ...formValues, note: value })
              }
            />
          </div>
        }
      />

      <h3>Contact List</h3>

      <Grid>
        <Grid.Row>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              {categoryId !== 0 && (
                <Button
                  color="primary"
                  onClick={() =>
                    navigate(`/create-contact-detail/null/${categoryId}`)
                  }
                >
                  Create New
                </Button>
              )}
              <Button color="blue" onClick={exportToCSV}>
                Export to Excel
              </Button>
              <Button primary onClick={handleConfirm}>
                Send Email
              </Button>
            </div>
          </div>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column width={16}>
            <div className="ag-theme-alpine" style={{ height: 600 }}>
              <AgGridReact
                rowData={rowData}
                defaultColDef={defaultColDef}
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                rowSelection="multiple"
              />
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default reduxForm({
  form: "contactListForm",
})(ContactListWithCat);
